var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Button',{attrs:{"type":"primary","icon":"md-add"},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v(" 新增 ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }